import { render, staticRenderFns } from "./Agentwindows.vue?vue&type=template&id=bf8d4272&scoped=true&"
import script from "./Agentwindows.vue?vue&type=script&lang=js&"
export * from "./Agentwindows.vue?vue&type=script&lang=js&"
import style0 from "./Agentwindows.vue?vue&type=style&index=0&id=bf8d4272&scoped=true&lang=css&"
import style1 from "./Agentwindows.vue?vue&type=style&index=1&id=bf8d4272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8d4272",
  null
  
)

export default component.exports